import React, { Component } from 'react';
import { Link } from 'react-router';

import DetailView from '../Common/DetailView';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import { Card, CardText } from 'material-ui/Card';

import AssetActions from '../../actions/AssetActionCreator';
import AssetHistoryStore from '../../stores/AssetHistoryStore';
import { Container } from 'flux/utils';
import { FormattedDate } from 'react-intl';
import { DateStyles } from '../../constants/CentricConstants';

import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import { withId } from '../Common/Decorators';

class AssetHistoryList extends Component {

    componentDidMount() {
        AssetActions.getHistoryById(this.props.id);
    }

    render() {
        return (
             <DetailView
                title="Asset History"
                backButton={true}
            >
                 <div className="cent-cards">
                     <Card className="cent-card">
                         <CardText>
                            <Table
                                height={this.props.display.height}
                                fixedHeader={this.props.display.fixedHeader}
                                fixedFooter={this.props.display.fixedFooter}
                                selectable={this.props.display.selectable}
                                multiSelectable={this.props.display.multiSelectable}
                                displayRowCheckbox={!!this.props.display.showCheckboxes}
                            >
                                <TableHeader
                                    enableSelectAll={this.props.display.enableSelectAll}
                                    displaySelectAll={this.props.display.enableSelectAll}
                                    adjustForCheckbox={this.props.display.enableSelectAll}
                                >
                                    <TableRow>
                                        <TableHeaderColumn>Version</TableHeaderColumn>
                                        <TableHeaderColumn>Title</TableHeaderColumn>
                                        <TableHeaderColumn>Type</TableHeaderColumn>
                                        <TableHeaderColumn>Date added</TableHeaderColumn>
                                        <TableHeaderColumn>Last updated</TableHeaderColumn>
                                        <TableHeaderColumn/>
                                    </TableRow>
                                </TableHeader>
                                <TableBody
                                    deselectOnClickaway={this.props.display.deselectOnClickaway}
                                    displayRowCheckbox={this.props.display.showCheckboxes}
                                    showRowHover={this.props.display.showRowHover}
                                    stripedRows={this.props.display.stripedRows}
                                >
                                    {this.state.data.map(({ id, versionName, name, type, dateAdded = null, dateUpdated = null }) => (
                                        <TableRow key={id}>
                                            <TableRowColumn>{versionName}</TableRowColumn>
                                            <TableRowColumn>{name}</TableRowColumn>
                                            <TableRowColumn>{type}</TableRowColumn>
                                            <TableRowColumn>
                                                <FormattedDate {...DateStyles.full} value={dateAdded} />
                                            </TableRowColumn>
                                            <TableRowColumn>
                                                <FormattedDate {...DateStyles.full} value={dateUpdated} />
                                            </TableRowColumn>
                                            <TableRowColumn style={{ textAlign: 'right' }}>
                                                {(type === 'document') && (<Link to={`/cent/asset/history/${id}/download`} target="_blank"><DownloadIcon /></Link>)}
                                            </TableRowColumn>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                         </CardText>
                     </Card>
                 </div>

            </DetailView>
        );
    }
}

AssetHistoryList.defaultProps = {
    display: {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        selectable: false,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: false,
        showCheckboxes: false
    }
};

AssetHistoryList.getStores = () => ([AssetHistoryStore]);
AssetHistoryList.calculateState = (state, {id}) => ({
    isFetching: AssetHistoryStore.isFetching(),
    data: AssetHistoryStore.getByAssetId(id),
});

export default withId(Container.create(AssetHistoryList, {withProps: true}));
